/**
 * Returns true iff an account has more than 1 topic tree (topic views are ignored)
 */
import {account} from "@/app/utils/Account";

export default function(options) {
    if (account().topicTrees?.length > 1) return options.fn(this);
    return options.inverse(this);
}